/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/repeat.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns a string constructed by concatenating `string` with itself the specified `number` of times.',
  examples: [
    'ROW a = "Hello!"\n| EVAL triple_a = REPEAT(a, 3)',
  ],
  params: {
    string: 'String expression.',
    number: 'Number times to repeat.',
  },
};

export default docs;
